/**
 * "Organisation" settings tab strip.
 *
 * Same shape as the workspace tab strips on the portfolio pages
 * (see TechnicalWorkspaceTabs.js) — route-driven, so each tab is a real
 * URL you can link to and reload into.
 */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';

const TABS = [
  { value: 'organisation', label: 'Organisation', path: '/settings' },
  { value: 'members',      label: 'Members',      path: '/settings/members' },
  { value: 'teams',        label: 'Teams',        path: '/settings/teams' },
];

export function resolveSettingsTab(pathname) {
  if (pathname.includes('/settings/teams'))   return 'teams';
  if (pathname.includes('/settings/members')) return 'members';
  return 'organisation';
}

export default function SettingsWorkspaceTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = resolveSettingsTab(pathname);

  return (
    <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', mb: 2 }}>
      <Tabs
        value={active}
        onChange={(_, v) => {
          const t = TABS.find((x) => x.value === v);
          if (t) navigate(t.path);
        }}
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{ sx: { height: 2 } }}
        sx={{ minHeight: 38, '& .MuiTab-root': { minHeight: 38, py: 1 } }}
      >
        {TABS.map((t) => (
          <Tab key={t.value} value={t.value} label={t.label} />
        ))}
      </Tabs>
    </Box>
  );
}
